import React from 'react';
import { GalleryPage } from './pages/GalleryPage';
export function App() {
  return <GalleryPage data-id="element-0" />;
}